import React from 'react';
import {AssetsSummary} from "../../models/Assets";
import {formatCurrency} from "../../../utils/format";
import {calculateCNWInEstateTotalValue,} from "../../AssetSummary/common/AssetSummaryCalculator";
import AssetList from "./AssetList";
import {InvestorGroupType, MemberGroup} from "../../../ClientManagement/models/InvestorGroupType";
import {Dropdown, DropdownItem} from "../../../components";
import {NO_OP} from "../../../constants/common";
import {hasInEstateAssets} from "../../AssetSummary/common/utils";
import AddAssetButtonDropdown from "../../AssetSummary/common/AddAssetButtonDropdown";
import {DeleteModalProps} from "../../common/AssetsView";
import InfoBannerForAccountAndPCR from "../../InfoBannerForAccountAndPCR";
import InfoBannerForStandaloneAndBankingDeposit from "../../InfoBannerForStandaloneAndBankingDeposit";
import {useAnalyticsTrackers} from "../../../utils/useAnalyticsTrackers";

export interface InEstateCurrentNetWorthProps {
    profileId: string,
    assets: AssetsSummary;
    investorGroup: InvestorGroupType;
    memberGroup: MemberGroup;
    showDeathBenefit?: boolean;
    toggleShowDeathBenefit?: () => void;
    onRemoveAssetClick: (deleteModalProps: DeleteModalProps) => void
    onRemoveInvestmentProgram: () => void;
    onRefreshInvestmentProgramHoldings: () => void;
}

const InEstateCurrentNetWorth = ({
                                     profileId,
                                     assets,
                                     investorGroup,
                                     memberGroup,
                                     showDeathBenefit,
                                     toggleShowDeathBenefit = NO_OP,
                                     onRemoveAssetClick,
                                     onRemoveInvestmentProgram,
                                     onRefreshInvestmentProgramHoldings
                                 }: InEstateCurrentNetWorthProps) => {
    const { page } = useAnalyticsTrackers("enableAssetsGoogleAnalytics");
    return <>
        <div className="section-header">
            <h3>
                <div>Your current net worth
                    is <b>{formatCurrency(calculateCNWInEstateTotalValue(assets, showDeathBenefit))}</b>:
                </div>
                {!hasInEstateAssets(assets) &&
                    <div className="condensed-subtitle">Begin by entering assets or entities</div>}
            </h3>
            <div>
                <Dropdown className="marginright-md"
                          panelWidth={220}
                          rounded={true}
                          dropdownKind={"menu"}
                          buttonSize={"medium"}
                          buttonIcon={"only"}
                          buttonKind={"borderless"}
                          iconNameOpen={"menu_dots"}
                          iconNameClose={"menu_dots"}
                          alignRight={true}
                          dynamicDropDirection={true}>
                    <DropdownItem className="page-action-menu-options"
                                  data-testid="showAtDeathTodayTotals"
                                  value=""
                                  itemText=""
                                  onClick={() => {
                                      page("Click_CurrentNW_ShowAtDeathTodayTotals");
                                      toggleShowDeathBenefit()}
                                    }
                    >
                        <div className="page-action-menu-options"
                             onClick={toggleShowDeathBenefit}>
                            <input
                                id="showAtDeathTodayTotals"
                                name="show-at-death-today-totals"
                                type="checkbox"
                                style={{marginRight: "10px"}}
                                aria-label="show-at-death-today-totals"
                                checked={showDeathBenefit}
                                onChange={toggleShowDeathBenefit}
                            />
                            Show At Death Today Totals
                        </div>
                    </DropdownItem>
                </Dropdown>
                <AddAssetButtonDropdown assets={assets}
                                        investorGroup={investorGroup}
                                        memberGroup={memberGroup}
                                        showFutureInflowButtons={false}/>
            </div>
        </div>
        <InfoBannerForAccountAndPCR assets={assets} profileId={profileId}/>
        <InfoBannerForStandaloneAndBankingDeposit assets={assets} profileId={profileId}/>
        <AssetList profileId={profileId}
                   assetsData={assets}
                   investorGroup={investorGroup}
                   showDeathBenefit={showDeathBenefit}
                   onRemoveAssetClick={onRemoveAssetClick}
                   onRemoveInvestmentProgram={onRemoveInvestmentProgram}
                   onRefreshInvestmentProgramHoldings={onRefreshInvestmentProgramHoldings}
        />
    </>;
}

export default InEstateCurrentNetWorth;